import Contact from 'components/Pages/Contact';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import { useGtmStaticPageView } from 'hooks/gtm/useGtmStaticPageView';
import { NextPageExtended } from 'types/global';
import { useGtmStaticPageViewEvent } from 'utils/Gtm/EventFactories';

const ContactPage: NextPageExtended<ServerSidePropsType> = () => {
    const gtmStaticPageViewEvent = useGtmStaticPageViewEvent('contact');
    useGtmStaticPageView(gtmStaticPageViewEvent);

    return <Contact />;
};

ContactPage.layout = 'withLastVisitedProducts';

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps({ context, domainConfig, redisClient, t });
});

export default ContactPage;
